import * as React from 'react';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import AdaptiveCustomElement from './AdaptiveCustomElement';
import { ActivityType } from '../service/ActivityFeedStorageItem';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
const styles = require('./AdaptiveCustomElement.scss');

export default class AdaptivePersona extends AdaptiveCustomElement {
    private emailAddress: string;
    private name: string;
    private itemType: ActivityType;

    protected renderComponent() {
        return (
            <>
                <PersonaControl
                    emailAddress={this.emailAddress}
                    name={this.name}
                    size={PersonaSize.size32}
                />
                <Icon className={styles.activityTypeIndicator} iconName={this.getIcon()} />
            </>
        );
    }

    private getIcon(): any {
        switch (this.itemType) {
            case ActivityType.Like:
                return ControlIcons.Like;
            case ActivityType.AtMention:
                return ControlIcons.Accounts;
            case ActivityType.TxpFlightReservation:
                return ControlIcons.AirplaneSolid;
            case ActivityType.TxpParcelDelivery:
                return ControlIcons.DeliveryTruck;
            case ActivityType.TxpInvoice:
                return ControlIcons.PaymentCard;
            default:
                return '';
        }
    }

    protected get className() {
        return styles.icon;
    }

    public getJsonTypeName() {
        return 'ActivityPersona';
    }

    public renderSpeech() {
        return '';
    }

    protected parseInternal(json: any) {
        this.emailAddress = json.emailAddress;
        this.name = json.name;
        this.itemType = json.itemType;
    }
}
